import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import injectSaga from '@utils/injectSaga';
import injectReducer from '@utils/injectReducer';
import IdleTimer from 'react-idle-timer';
import Container from '@components/Container';
import ClickAwayListener from '@components/ClickAwayListener';
import Text, { TEXT_SIZE, TEXT_COLOR } from '@components/Text';
import { ROUTES } from '@shared/constants';
import MessagesMenu from './components/MessagesMenu';
import {
  Wrapper,
  Logo,
  StyledLocaleToggle,
  HelpMenuWrapper,
  StyledHelpIcon,
  StyledHelpMenuContactIcon,
  UserInfoContainer,
  StyledAvatar,
  StyledChevronDown,
  StyledChevronUp,
  UserPanelWrapper,
  UserMenuContainer,
  StyledMenuItem,
  StyledSettingsIcon,
  StyledLogOutIcon,
  StyledRolesManagementIcon,
  StyledBusinessUnitsIcon,
  StyledInvitesIcon,
  StyledAnalyticsIcon,
  StyledResourcesIcon,
  StyledRecordIcon,
  StyledUsersIcon,
  StyledMentorDashboard,
  StyledStaffIcon,
  TopMenuContainer,
  TopMenuGroup,
  TopMenuItem,
  TopMenuLabel,
  TopMenuChevron,
  TopDropdownMenu,
  TopDropdownItem,
  RightControlsContainer,
  StyledPeopleIcon,
  StyledOrganizationIcon,
  StyledTopResourcesIcon,
  StyledTopAnalyticsIcon,
  //  NotificationIconWrapper,  StyledExerciseAreaTab, StyledNotificationIcon,
} from './styles';
import LogoImage from './logo_sm.png';
import { ENVIRONMENT } from '@services/servers';
// import POPUP_TYPES from '../PopUp/types';
// import { openPopUp as openPopUpAction } from '../PopUp/actions';
import { logOut as logOutAction } from '../../actions';
import { startNewConversationAction } from '../Messaging/actions';
import saga from '../Messaging/saga';
import reducer from '../Messaging/reducer';
import ServerVersion from '@components/ServerVersion';
import ClientVersion from '@components/ClientVersion';
import { openPopUp } from "@containers/App/containers/PopUp/actions";
import POPUP_TYPES from "@containers/App/containers/PopUp/types";
import VideoMonitorService from '@services/videoMonitorService';
import { withTranslation } from 'react-i18next';
import { isSharedVideoChatV2MeetingActive } from '@services/meetingPresenceService';
import { ROLES } from '@shared/constants/roles';

const WATCHER_ACTIONS = {
  ACTION: 'ACTION',
  PAUSE: 'PAUSE',
};

const MINUTE_IN_MS = 1000 * 60;

const ACTIVITY_TIMES = {
  SUPERVISOR_IDLE_TIME: MINUTE_IN_MS * 15,
  MENTOR_IDLE_TIME: MINUTE_IN_MS * 15,
  PATIENT_IDLE_TIME: MINUTE_IN_MS * 15,
  LOGOUT_TIME: MINUTE_IN_MS
}

class NavigationBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isUserMenuShown: false,
      isHelpMenuShown: false,
      openTopMenu: null,
      topMenuAnchorEl: null,
    };
    this.userActivityWatcher = React.createRef();
    // BroadcastChannel is used to communicate with other browser tabs with app,
    // so user can be active on another tab
    this.watchingChannel = new BroadcastChannel('activity_watchers_channel');
    this.watchingChannel.onmessage = this.handleWatchingChannelMessage(this.userActivityWatcher);
  }

  componentDidUpdate(prevProps) {
    if (this.userActivityWatcher.current) {
      if (this.props.connectedToChat && !prevProps.connectedToChat) {
        this.userActivityWatcher.current.pause();
        this.watchingChannel.postMessage(WATCHER_ACTIONS.PAUSE);
      } else if (!this.props.connectedToChat && prevProps.connectedToChat) {
        this.userActivityWatcher.current.reset();
      }
    }
  }

  componentWillUnmount() {
    if (this.userActivityWatcher.current && this.props.connectedToChat) {
      this.watchingChannel.postMessage(WATCHER_ACTIONS.ACTION);
    }
  }

  handleWatchingChannelMessage = (watcher) => (ev) => {
    if (watcher.current) {
      switch (ev.data) {
        case WATCHER_ACTIONS.ACTION:
          watcher.current.reset();
          break;
        case WATCHER_ACTIONS.PAUSE:
          watcher.current.pause();
          break;
        default:
      }
    }
  };

  handleLogOut = () => {
    const {
      exerciseInProgress,
      lessonInProgress,
      currentLessonActivity,
      logOut,
    } = this.props;
    const logOutData = {
      exerciseInProgress,
      lessonInProgress,
    }
    if (currentLessonActivity) {
      logOutData.activityLessonId = currentLessonActivity.id
    }
    if (VideoMonitorService) {
      logOutData.archiveID = VideoMonitorService.archiveId
    }

    this.toggleUserMenu();
    logOut(logOutData);
  };

  handleSettingsOpening = () => {
    const { history } = this.props;
    history.push(ROUTES.SETTINGS);
  };

  navigateRolesManagement = () => {
    const { history } = this.props;
    history.push(ROUTES.ROLES_MANAGEMENT);
  };

  navigateBusinessUnits = () => {
    const { history } = this.props;
    history.push(ROUTES.BUSINESS_UNITS);
  };

  navigateInvites = () => {
    const { history } = this.props;
    history.push(ROUTES.INVITES);
  };

  navigateAnalytics = () => {
    const { history } = this.props;
    history.push(ROUTES.ANALYTICS);
  };

  navigateResources = () => {
    const { history } = this.props;
    history.push(ROUTES.RESOURCES_MANAGER);
  };

  navigateHomePage = () => {
    const { history, defaultPage } = this.props;
    history.push(defaultPage);
  };

  navigateUsers = () => {
    const { history } = this.props;
    history.push(ROUTES.USERS.LIST);
  };

  navigateToStaffPage = () => {
    const { history } = this.props;
    history.push(ROUTES.STAFF.LIST);
  };

  navigateMentorDashboard = () => {

    const { history } = this.props;
    history.push(ROUTES.PENDING_DASHBOARD);
  }

  toggleTopMenu = (menu, anchorEl) => {
    this.setState((prevState) => ({
      openTopMenu: prevState.openTopMenu === menu ? null : menu,
      topMenuAnchorEl: prevState.openTopMenu === menu ? null : anchorEl,
    }));
  };

  closeTopMenu = () => {
    this.setState({ openTopMenu: null, topMenuAnchorEl: null });
  };

  navigateFromTopMenu = (navigate) => {
    this.setState({ openTopMenu: null, topMenuAnchorEl: null }, navigate);
  };

  renderTopMenuDropdown = ({ id, label, icon, items, activePaths }) => {
    const { openTopMenu, topMenuAnchorEl } = this.state;
    const pathname = this.props.history.location?.pathname || '';
    const isOpen = openTopMenu === id;
    const isActive = activePaths.some((path) => pathname === path || pathname.startsWith(`${path}/`));

    if (items.length === 1) {
      return (
        <TopMenuGroup>
          <TopMenuItem
            id={`top-menu-${id}`}
            type="button"
            isCurrent={isActive}
            aria-current={isActive ? 'page' : undefined}
            onClick={() => this.navigateFromTopMenu(items[0].navigate)}
          >
            {icon}
            <TopMenuLabel>{label}</TopMenuLabel>
          </TopMenuItem>
        </TopMenuGroup>
      );
    }

    return (
      <TopMenuGroup>
        <TopMenuItem
          id={`top-menu-${id}`}
          type="button"
          isCurrent={isActive}
          isOpen={isOpen}
          aria-expanded={isOpen}
          aria-haspopup="menu"
          aria-controls={isOpen ? `top-menu-${id}-dropdown` : undefined}
          aria-current={isActive ? 'page' : undefined}
          onClick={(event) => this.toggleTopMenu(id, event.currentTarget)}
        >
          {icon}
          <TopMenuLabel>{label}</TopMenuLabel>
          <TopMenuChevron isOpen={isOpen} />
        </TopMenuItem>
        {isOpen && (
          <TopDropdownMenu
            id={`top-menu-${id}-dropdown`}
            anchorEl={topMenuAnchorEl}
            open
            onClose={this.closeTopMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            MenuListProps={{ 'aria-labelledby': `top-menu-${id}` }}
            transitionDuration={0}
            disableScrollLock
          >
            {items.map((item) => {
              const isItemCurrent = item.activePaths.some((path) => pathname === path || pathname.startsWith(`${path}/`));

              return (
                <TopDropdownItem
                  key={item.label}
                  disableGutters
                  isCurrent={isItemCurrent}
                  aria-current={isItemCurrent ? 'page' : undefined}
                  onClick={() => this.navigateFromTopMenu(item.navigate)}
                >
                  {item.icon}
                  <TopMenuLabel>{item.label}</TopMenuLabel>
                </TopDropdownItem>
              );
            })}
          </TopDropdownMenu>
        )}
      </TopMenuGroup>
    );
  };

  renderTopMenu = () => {
    const { user, t } = this.props;
    const isTechAdmin = user.roles.includes(ROLES.TECH_ADMIN);
    const hasAdminPermissions = user.roles.includes('30') || user.roles.includes('40') || user.roles.includes('41');
    const isMentor = user.roles.includes('10') || user.roles.includes('11') || user.roles.includes('20') || user.roles.includes('21') || user.roles.includes('22');

    if (isMentor && !hasAdminPermissions) {
      return (
        <TopMenuContainer>
          {this.renderTopMenuDropdown({
            id: 'activities',
            label: t('UI.mentorDashboard'),
            icon: <StyledMentorDashboard />,
            items: [{ label: t('UI.mentorDashboard'), icon: <StyledMentorDashboard />, navigate: this.navigateMentorDashboard, activePaths: [ROUTES.PENDING_DASHBOARD] }],
            activePaths: [ROUTES.PENDING_DASHBOARD],
          })}
          {this.renderTopMenuDropdown({
            id: 'users',
            label: t('UI.userRecords'),
            icon: <StyledUsersIcon />,
            items: [{ label: t('UI.userRecords'), icon: <StyledUsersIcon />, navigate: this.navigateUsers, activePaths: [ROUTES.USERS.LIST] }],
            activePaths: [ROUTES.USERS.LIST],
          })}
        </TopMenuContainer>
      );
    }

    if (hasAdminPermissions) {
      return (
        <TopMenuContainer>
          {this.renderTopMenuDropdown({
            id: 'people',
            label: 'People',
            icon: <StyledPeopleIcon />,
            items: [
              { label: t('UI.userRecords'), icon: <StyledUsersIcon />, navigate: this.navigateUsers, activePaths: [ROUTES.USERS.LIST] },
              { label: t('UI.staffRecords'), icon: <StyledStaffIcon />, navigate: this.navigateToStaffPage, activePaths: [ROUTES.STAFF.LIST] },
            ],
            activePaths: [ROUTES.USERS.LIST, ROUTES.STAFF.LIST],
          })}
          {this.renderTopMenuDropdown({
            id: 'organization',
            label: 'Organization',
            icon: <StyledOrganizationIcon />,
            items: [
              { label: t('Informative.Labels.businessUnits'), icon: <StyledBusinessUnitsIcon />, navigate: this.navigateBusinessUnits, activePaths: [ROUTES.BUSINESS_UNITS] },
              { label: t('UI.rolesManagement'), icon: <StyledRolesManagementIcon />, navigate: this.navigateRolesManagement, activePaths: [ROUTES.ROLES_MANAGEMENT] },
            ],
            activePaths: [ROUTES.BUSINESS_UNITS, ROUTES.ROLES_MANAGEMENT],
          })}
          {isTechAdmin && (
            this.renderTopMenuDropdown({
              id: 'resources',
              label: t('Common.UI.resources'),
              icon: <StyledTopResourcesIcon />,
              items: [{ label: t('Common.UI.resources'), icon: <StyledResourcesIcon />, navigate: this.navigateResources, activePaths: [ROUTES.RESOURCES_MANAGER] }],
              activePaths: [ROUTES.RESOURCES_MANAGER],
            })
          )}
          {this.renderTopMenuDropdown({
            id: 'analytics',
            label: t('UI.analytics'),
            icon: <StyledTopAnalyticsIcon />,
            items: [{ label: t('UI.analytics'), icon: <StyledAnalyticsIcon />, navigate: this.navigateAnalytics, activePaths: [ROUTES.ANALYTICS] }],
            activePaths: [ROUTES.ANALYTICS],
          })}
        </TopMenuContainer>
      );
    }

    return null;
  };

  toggleHelpMenu = () => {
    this.setState((prevState) => ({
      isHelpMenuShown: !prevState.isHelpMenuShown,
    }));
  };

  toggleUserMenu = () => {
    this.setState((prevState) => ({
      isUserMenuShown: !prevState.isUserMenuShown,
    }));
  };

  redirectToMessaging = () => {
    const { history, startNewConversation } = this.props;
    history.push(ROUTES.MESSAGING);
    startNewConversation();
  };

  userInactivityDialog = () => {
    if (isSharedVideoChatV2MeetingActive()) {
      // Do not show inactivity popup or force logout while user is inside a V2 meeting.
      this.userActivityWatcher.current?.reset?.();
      return;
    }

    const { dispatchOpenPopUp, t } = this.props;
    const logOutTimeOut = setTimeout(() => {
      this.handleLogOut()
    }, ACTIVITY_TIMES.LOGOUT_TIME)
    dispatchOpenPopUp(POPUP_TYPES.CONFIRM, {
      titleText: t('Informative.Notifying.userInactive'),
      bodyText: t('Informative.Confirming.inactivityQuestion'),
      confirmText: t('Actions.Auth.logOut'),
      cancelText: t('Actions.Instance.continue'),
      onConfirm: (finishLesson) => {
        if (finishLesson) {
          this.handleLogOut()
        }
      },
      onClose: () => {
        clearTimeout(logOutTimeOut)
      }
    });
  }

  renderUserActivityWatcher = () => {
    const { user } = this.props;
    const isSupervisor = user.roles.includes('30');
    const isClinicalMentor = user.roles.includes('20') || user.roles.includes('10');

    let timeout;

    if (isSupervisor) {
      timeout = ACTIVITY_TIMES.SUPERVISOR_IDLE_TIME;
    } else if (isClinicalMentor) {
      timeout = ACTIVITY_TIMES.MENTOR_IDLE_TIME;
    } else {
      timeout = ACTIVITY_TIMES.PATIENT_IDLE_TIME;
    }

    // checks activity of user, if user is inactive, logout dialog is shown, and logs out after 1 minute
    return (
      <IdleTimer
        ref={this.userActivityWatcher}
        element={document}
        onIdle={this.userInactivityDialog}
        onAction={() => this.watchingChannel.postMessage(WATCHER_ACTIONS.ACTION)}
        throttle={MINUTE_IN_MS}
        timeout={timeout}
      />
    );
  };

  renderHelpMenu = () => {
    const {t} = this.props;
    const { isHelpMenuShown } = this.state;

    return (
      <ClickAwayListener
        onClickAway={() => {
          this.state.isHelpMenuShown && this.toggleHelpMenu();
        }}
      >
        <HelpMenuWrapper
          isActive={isHelpMenuShown}
          onClick={this.toggleHelpMenu}
        >
          <StyledHelpIcon />
          {isHelpMenuShown && (
            <UserMenuContainer className="navigation-menu">
              <StyledMenuItem onClick={this.redirectToMessaging}>
                <StyledHelpMenuContactIcon />
                <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.DISABLED_LIGHT}>
                  {t('Actions.General.contactUs')}
                </Text>
              </StyledMenuItem>
              {ENVIRONMENT !== 'prod' && (
                <>
                  <StyledMenuItem>
                    <ServerVersion showIcon />
                  </StyledMenuItem>
                  <StyledMenuItem>
                    <ClientVersion showIcon />
                  </StyledMenuItem>
                </>
              )}
            </UserMenuContainer>
          )}
        </HelpMenuWrapper>
      </ClickAwayListener>
    );
  };

  renderUserInfo = () => {
    const {user, t} = this.props;
    const { isUserMenuShown } = this.state;
    const hasAdminPermissions = user.roles.includes('30') || user.roles.includes('40') || user.roles.includes('41');

    return (
      <ClickAwayListener
        onClickAway={() => {
          this.state.isUserMenuShown && this.toggleUserMenu();
        }}
      >
        <UserPanelWrapper
          onClick={() => {
            this.toggleUserMenu();
          }}
        >
          <UserInfoContainer>
            <StyledAvatar img={user.avatar} />
            <Text
              size={TEXT_SIZE.T3}
              textColor={TEXT_COLOR.REVERSED}
              margin="0 10px 0 0"
            >
              {`${user.firstName} ${user.lastName}`}
            </Text>
            {isUserMenuShown ? <StyledChevronUp /> : <StyledChevronDown />}
          </UserInfoContainer>
          {isUserMenuShown && (
            <UserMenuContainer>
              {hasAdminPermissions && (
                <StyledMenuItem onClick={this.navigateInvites}>
                  <StyledInvitesIcon />
                  <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.DISABLED_LIGHT}>
                    {t('UI.invites')}
                  </Text>
                </StyledMenuItem>
              )}
              <StyledMenuItem onClick={this.handleSettingsOpening}>
                <StyledSettingsIcon />
                <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.DISABLED_LIGHT}>
                  {t('Common.UI.settings')}
                </Text>
              </StyledMenuItem>
              <StyledMenuItem onClick={this.handleLogOut}>
                <StyledLogOutIcon />
                <Text size={TEXT_SIZE.H4} textColor={TEXT_COLOR.DISABLED_LIGHT}>
                  {t('Actions.Auth.logOut')}
                </Text>
              </StyledMenuItem>
            </UserMenuContainer>
          )}
        </UserPanelWrapper>
      </ClickAwayListener>
    );
  };

  renderRecordIcon = () => {
    const { recordingVideo, connectedToMirror } = this.props;
    if (recordingVideo || connectedToMirror) return <StyledRecordIcon />
  }

  render() {
    return (
      <>
        <Wrapper>
          {this.renderUserActivityWatcher()}
          <Container>
            <Logo onClick={this.navigateHomePage} src={LogoImage} />
          </Container>
          <RightControlsContainer>
            <Container margin="0 10px 0 0">
              <StyledLocaleToggle />
            </Container>
            <MessagesMenu />
            {this.renderRecordIcon()}
            {this.renderUserInfo()}
          </RightControlsContainer>
        </Wrapper>
        {this.renderTopMenu()}
      </>
    );
  }
}

NavigationBar.propTypes = {
  intl: PropTypes.object,
  history: PropTypes.object,
  user: PropTypes.object,
  logOut: PropTypes.func,
  defaultPage: PropTypes.string,
  startNewConversation: PropTypes.func,
  connectedToChat: PropTypes.bool,
  dispatchOpenPopUp: PropTypes.func,
  videoChatV2InMeeting: PropTypes.bool,
};

export { NavigationBar };

export const mapStateToProps = (state) => {
  const defaultPage = state.getIn(['app', 'authentication', 'user', 'defaultPage']);
  const { connectedToChat } = state.get('videoChat') ? state.getIn(['videoChat']).toJS() : false;
  const { currentLessonActivity, lessonInProgress } = state.get('currentLesson') ? state.getIn(['currentLesson']).toJS() : false;
  const { exerciseInProgress } = state.get('currentPractice') ? state.getIn(['currentPractice']).toJS() : false;
  const { recordingVideo, connectedToMirror } = state.get('videoMirror') ? state.getIn(['videoMirror']).toJS() : false;
  return {
    defaultPage,
    connectedToChat,
    currentLessonActivity,
    lessonInProgress,
    exerciseInProgress,
    recordingVideo,
    connectedToMirror,
    videoChatV2InMeeting: state.get('app') ? state.getIn(['app', 'videoChatV2InMeeting']) : false,
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    logOut: (data) => dispatch(logOutAction(data)),
    startNewConversation: () => dispatch(startNewConversationAction()),
    dispatchOpenPopUp: (type, props) => dispatch(openPopUp(type, props)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'messaging', reducer });
const withSaga = injectSaga({ key: 'messaging', saga });

export default compose(
  withReducer,
  withRouter,
  withSaga,
  withConnect,
  withTranslation()
)(NavigationBar);
